import { BrowserRouter as Router,Route, Routes } from 'react-router-dom';

import './styles/main.css';
import Landing from './components/landing';
import Nav from './components/nav';
import SignUp from './components/signUp';
import Login from './components/login';
import Shop from './components/shop';
import Cart from './components/cart'

export default function App() {
    
    return (
            <Router>
                <Nav />
                <Routes>
                    <Route path="/" exact element={<Landing/>} />
                    <Route path="/signup" element={<SignUp/>} />
                    <Route path="/login" element={<Login/>} />
                    <Route path="/shop" element={<Shop/>} />
                    <Route path="/cart" element={<Cart/>} />
                </Routes>
                <footer className='footer'>
                    <div className='footer-one'>
                    Made with <span style={{color: '#306EFF'}}>&#10084;</span> by <span style={{fontWeight: 'bold', color: '#306EFF'}}>surya</span>
                    </div>
                    <div className='footer-two'>
                    <span style={{fontSize: '15px'}}>&copy;</span>shoppee
                    </div>
                </footer>
            </Router>
    )
}